import { Horizontal, GraviButton } from '@gravitate-js/excalibrr'

type FooterButtonsProps = {
  isLoading?: boolean
}

export function FooterButtons({ isLoading = false }: FooterButtonsProps) {
  return (
    <Horizontal
      style={{ justifyContent: 'flex-end', borderTop: '1px solid var(--gray-200)' }}
      className='pt-3 mt-2'
      gap={8}
    >
      <GraviButton htmlType='reset'>Cancel</GraviButton>
      <GraviButton theme2 htmlType='submit' loading={isLoading}>
        Confirm
      </GraviButton>
    </Horizontal>
  )
}
